// Standard library imports
import React from 'react';
// External library imports
import { Form, Formik } from 'formik';
// Internal module imports
import classes from '../../../styles/CapacityContent.module.css';
import Table from '../../../components/Table/Table';
import TabsComponent from '../../../components/Tabs/Tabs';
import { momentTimeFormater } from '../../../utils/dateHelper';
import { TextArea } from '../../../components/Inputs/Input';
import ovenClasses from '../Index.module.css';
import { AFRR_MARKET_TYPES } from '../../../constants';

const getCapacityPriceData = (request = {}, market) => {
    const { capacity = [], price = [], regulationPrice = [] } = request;
    const data = capacity.map((n, i) => {
        const slot = i + 1;
        return {
            slot,
            hour: `${i}-${slot}`,
            price: price[i],
            capacity: n,
            ...(AFRR_MARKET_TYPES.includes(market) ? { regulationPrice: regulationPrice[i] } : {}),
        };
    });
    return data;
};

const getExcludedDaysdata = (request = {}) => {
    const { excludedDays = [] } = request;
    return excludedDays.map((e, i) => ({ ...e, 's.no': i + 1, date: momentTimeFormater(e.date).format('YYYY-MM-DD') }));
};

const RequestOverview = ({ market, request, setOpen }) => {
    const capacityPriceData = getCapacityPriceData(request, market);
    const excludedDaysdata = getExcludedDaysdata(request);
    const tableHeaders = ['Slot', 'Hour', 'Capacity', 'Price'];
    const tableKey = ['slot', 'hour', 'capacity', 'price'];
    if (AFRR_MARKET_TYPES.includes(market)) {
        tableHeaders.push('Energy Price');
        tableKey.push('regulationPrice');
    }
    const tabs = [
        {
            name: 'Capacity/Price',
            component: (
                <div style={{ maxHeight: '50vh', overflowY: 'scroll', padding: '0.5vw', width: '40vw' }}>
                    {request?.customBidding && <Table head={tableHeaders} keys={tableKey} data={capacityPriceData} />}

                    <div>
                        <Formik
                            initialValues={{
                                note: request?.note || '',
                            }}
                            enableReinitialize
                        >
                            {({ errors, touched, values, isValidating, ...props }) => (
                                <Form>
                                    <div className={ovenClasses.FieldControl}>
                                        <label for="note">Note</label>
                                        <TextArea name={`note`} label="Note" disabled={true} />
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </div>
                </div>
            ),
        },
        {
            name: 'Excluded Days',
            component: <Table head={['S.No', 'Date', 'Reason']} keys={['s.no', 'date', 'reason']} data={excludedDaysdata} />,
        },
    ];
    return (
        <div>
            <TabsComponent tabs={tabs} />
            <div className={classes.ButtonContainer2}>
                <div className="btn-secondary" onClick={() => setOpen(false)}>
                    Close
                </div>
            </div>
        </div>
    );
};

export default RequestOverview;
